import { render, staticRenderFns } from "./Generator.vue?vue&type=template&id=044484fa&scoped=true&"
import script from "./Generator.vue?vue&type=script&lang=ts&"
export * from "./Generator.vue?vue&type=script&lang=ts&"
import style0 from "./Generator.vue?vue&type=style&index=0&id=044484fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044484fa",
  null
  
)

export default component.exports